import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RewardsService {
    constructor(private _apiService: ApiService) {}

    redeemCode(code: string): Observable<any> {
        const url = API_ENDPOINTS.REDEEM + '/' + code;
        return this._apiService.get(url);
    }

    getReferralSummry(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.REFERRAL_SUMMRY);
    }
}
